import { render, staticRenderFns } from "./ProfileImageDisabledStoryView.vue?vue&type=template&id=2c595ed4&scoped=true&"
import script from "./ProfileImageDisabledStoryView.vue?vue&type=script&lang=js&"
export * from "./ProfileImageDisabledStoryView.vue?vue&type=script&lang=js&"
import style0 from "./ProfileImageDisabledStoryView.vue?vue&type=style&index=0&id=2c595ed4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c595ed4",
  null
  
)

export default component.exports